// Locale specific metadata
export enum LocaleKey {
  EN_US = 'en-us',
  EN_GB = 'en-gb',
}

export const siteMetadata: Record<
  LocaleKey,
  {
    url: string
    country: string
    code: string
    label: string
    language: string
    gtmId: string
  }
> = {
  [LocaleKey.EN_US]: {
    url: 'https://raisingcanes.com',
    country: 'United States',
    code: 'US',
    label: 'US - English',
    language: 'English',
    gtmId: 'GTM-TZNRWZN',
  },
  [LocaleKey.EN_GB]: {
    url: 'https://raisingcanes.co.uk',
    country: 'United Kingdom',
    code: 'UK',
    label: 'UK - English',
    language: 'English',
    gtmId: 'GTM-TH6J2SK9',
  },
}
